import type { InventoryVariant } from '@/lib/api/schemas/inventory.schema'
import { MarketplaceBadgeList } from '@/components/warehouse/primitives'
import type { MarketplaceBadge } from '@/lib/warehouse/projection'
import { displayArticle, productStatusOf } from '@/lib/warehouse/projection'
import { unavailableReasonText, warehouseProductStatusLabels } from '@/lib/warehouse/labels'

type HeadingTag = 'h1' | 'h2'

export function ProductCardIdentity({ variant, badges, heading = 'h2' }: {
  variant: InventoryVariant
  badges: readonly MarketplaceBadge[]
  heading?: HeadingTag
}) {
  const productStatus = productStatusOf(variant)
  const manufacturer = variant.identity.manufacturer?.trim() || null
  const manufacturerReason = variant.identity.manufacturerUnavailableReason?.trim() || 'manufacturer.not_recorded'
  const Heading = heading

  return (
    <div className="min-w-0">
      <p className="text-base font-semibold text-ink">
        {displayArticle(variant) || '—'}{variant.identity.normalizedSize ? ` · ${variant.identity.normalizedSize} размер` : ''}
      </p>
      <div className="mt-0.5 flex min-w-0 flex-wrap items-center gap-2">
        <Heading className="min-w-0 break-words text-base font-semibold text-ink sm:truncate" title={variant.title ?? 'Без названия'}>
          {variant.title ?? 'Без названия'}
        </Heading>
        <span data-product-status={productStatus.status} className="inline-flex min-w-max items-center whitespace-nowrap rounded-full bg-bone px-2 py-1 text-[11px] font-medium text-ink-2">
          {warehouseProductStatusLabels[productStatus.status]}
        </span>
      </div>
      <p
        data-reason={manufacturer === null ? manufacturerReason : undefined}
        className={`mt-1 min-w-0 break-words text-xs ${manufacturer === null ? 'text-ink-muted' : 'text-ink-2'}`}
      >
        {manufacturer === null ? unavailableReasonText(manufacturerReason) : `Производитель: ${manufacturer}`}
      </p>
      <div className="mt-1">
        <MarketplaceBadgeList badges={badges} compact connectionOnly />
      </div>
    </div>
  )
}
